// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/flight-instrument-sensors.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/flight-instrument-sensors/flight-instrument-sensors.js';

mount([g0]);
